import RentalBranchLocation from './RentalBranchLocation';

export default RentalBranchLocation;
